export const DEFAULT_AGENT_LANGUAGE_CODE = 'hy-AM';

export const agentLanguageOptions = [
  {
    value: DEFAULT_AGENT_LANGUAGE_CODE,
    title: 'Հայերեն',
    subtitle: 'Ագենտը պատասխանում է հայերեն և սպասում է հայերեն մուտք։',
  },
];

const supportedLanguageCodes = new Set(agentLanguageOptions.map((option) => option.value));

export const normalizeAgentLanguageCode = (value) => (
  supportedLanguageCodes.has(value) ? value : DEFAULT_AGENT_LANGUAGE_CODE
);
